import React from 'react'
import classNames from 'classnames'

type ClerkFormSkeletonProps = {
  className?: string
  isSignUp?: boolean
}

export const ClerkFormSkeleton: React.FC<ClerkFormSkeletonProps> = ({
  className: classNameFromProps,
  isSignUp = false,
}) => {
  return (
    <div
      className={classNames(
        classNameFromProps,
        'bg-white rounded-lg w-[25rem] max-w-[calc(-2.5rem+100vw)] p-10',
        {
          'md:h-[640px]': isSignUp,
          'h-[500px]': !isSignUp,
        },
      )}
    >
      <div className={'w-3/4 mx-auto h-6 bg-gray-300 rounded-sm animate-pulse mb-2'}></div>
      <div className={'w-4/5 mx-auto h-4 bg-gray-200 rounded-sm animate-pulse mb-8'}></div>
      <div className={'w-full flex flex-col md:flex-row gap-2'}>
        <div
          className={'w-full h-8 bg-gray-50 border border-border-subtle rounded-sm animate-pulse'}
        ></div>
        <div
          className={'w-full h-8 bg-gray-50 border border-border-subtle rounded-sm animate-pulse'}
        ></div>
      </div>
      <div className={'w-full h-0.5 my-7 bg-gray-100 rounded-sm animate-pulse'}></div>
      {isSignUp && (
        <div className={'w-full flex flex-col md:flex-row gap-8 md:gap-2 mb-8'}>
          <div className={'w-full h-full'}>
            <div className={'w-1/2 h-4 bg-gray-200 rounded-sm animate-pulse mb-2'}></div>
            <div className={'w-full h-8 bg-gray-100 rounded-sm animate-pulse'}></div>
          </div>
          <div className={'w-full h-full'}>
            <div className={'w-1/2 h-4 bg-gray-200 rounded-sm animate-pulse mb-2'}></div>
            <div className={'w-full h-8 bg-gray-100 rounded-sm animate-pulse'}></div>
          </div>
        </div>
      )}
      <div className={'mb-8'}>
        <div className={'w-1/2 h-4 bg-gray-200 rounded-sm animate-pulse mb-2'}></div>
        <div className={'w-full h-8 bg-gray-100 rounded-sm animate-pulse'}></div>
      </div>
      <div className={'mb-8'}>
        <div className={'w-1/4 h-4 bg-gray-200 rounded-sm animate-pulse mb-2'}></div>
        <div className={'w-full h-8 bg-gray-100 rounded-sm animate-pulse'}></div>
      </div>
      {isSignUp && (
        <div className={'w-full mx-auto h-4 bg-gray-200 rounded-sm animate-pulse mb-6'}></div>
      )}

      <div className={'w-full h-8 bg-gray-300 rounded-sm animate-pulse'}></div>
    </div>
  )
}
